export class Risk {
  id: number;
  title: string;
  description: string;
  mitigatingActions: string;
  grossCost: number;
  netCost: number;
  probability: number;
  impact: number;
  alertLevel: number;

  category: number;
  createdAt: Date;
  updatedAt: Date;
  reviewPeriod: number;

  riskStatus: number;
  riskType: number;
  strategicRiskType: number;
  operationalRiskType: number;
  financialRiskType: number;

  proximity: number;
  emergingRiskSegment: number;

  owner: number;
  lineManager: number;
  department: number;
  regulatoryDepartment: number;

  lastReviewDate: Date;
  nextReviewDate: Date;
  notes: string;
  global: number;

  previousProbability: number;
  previousImpact: number;
  previousproximity: number;

  randomOffset: number;
  impactOutlook: number; // RDP-158
}
